import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import MessageStatusIndicator from './MessageStatusIndicator';

/**
 * MessageItem Component
 * Displays a single message with delivery status
 */
const MessageItem = ({ message, isCurrentUser }) => {
  const formatTime = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  // Handle different field naming conventions from backend
  const getTimestamp = () => {
    return message.sent_at || message.SentAt || message.created_at || message.CreatedAt || '';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isCurrentUser ? 'flex-end' : 'flex-start',
        mb: 2
      }}
    >
      <Paper
        elevation={1}
        sx={{
          p: 1.5,
          maxWidth: '70%',
          backgroundColor: isCurrentUser ? 'primary.light' : 'grey.100',
          color: isCurrentUser ? 'primary.contrastText' : 'text.primary'
        }}
      >
        <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
          {message.content}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            mt: 0.5
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: isCurrentUser ? 'primary.contrastText' : 'text.secondary',
              opacity: 0.8
            }}
          >
            {formatTime(getTimestamp())}
          </Typography>

          {isCurrentUser && (
            <MessageStatusIndicator
              deliveryStatus={message.delivery_status}
              isQueued={message.is_queued || false}
              queueStatus={message.queue_status || null}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default MessageItem;
